module.exports = __webpack_public_path__ + "static/media/photo16.255d16d6.jpg";